<div class=" row mt-3 " style="padding: 10px;">
                       
                        
    <div class="col-md-12 " >
     
        <div class="row">
                <mat-form-field class="col-md-3" appearance="outline">
                    <mat-label>Product</mat-label>
                    <mat-select matNativeControl name="product"  (selectionChange)="onChangeProduct($event)" [(ngModel)]="product">
                      <mat-option [disabled]="product==='HOTEL'"  *ngFor="let product of productList" [value]="product">{{product}}</mat-option>
                    </mat-select>  
                  </mat-form-field>
                  <mat-form-field class="col-md-3" appearance="outline">
                    <mat-label>Payment Medium</mat-label>
                    <mat-select matNativeControl name="medium" multiple (selectionChange)="onChangemedium($event)" >
                      <mat-option  *ngFor="let list of activeList" [value]="list">{{list}}</mat-option>
                    </mat-select>  
                  </mat-form-field>
                  <div class="col-md-1 " >
                  <button [disabled]="element.length===0"  class="btn btn-outline-primary btn-sm " style="padding-top: 14px;padding-bottom: 14px; padding-left: 14px; padding-right: 14px;" (click)=" onAddMedium()"><img src="assets/images/Add_24.png"></button>
                  </div>
            
            </div>
      <table mat-table [dataSource]="mediumlist" multiTemplateDataRows style="background-color: transparent;">
     
    
       <ng-container matColumnDef="paymentMedium" >
        <th mat-header-cell *matHeaderCellDef>Allow Payment Medium</th>
        <td mat-cell *matCellDef="let element"> {{element.mediumName}} </td>
       </ng-container>
     
       <ng-container matColumnDef="official" >
        <th mat-header-cell *matHeaderCellDef>Official</th>
        <td mat-cell *matCellDef="let element"> 
            <div class="col-md-12 ">
            <mat-select matNativeControl class="form-control small font mt-2 mb-2"  name="official" [(ngModel)]="element.isBusinessEnabled" >
                <mat-option  class="mat-primary" value="true">Enabled</mat-option>
                <mat-option  class="mat-primary" value="false">Disabled</mat-option>

              </mat-select>  
            </div>
             </td>
       </ng-container>
       <!-- [ngStyle]="{'background-color': element.personal === 'true' ? 'green' : 'rgb(209, 30, 32)'}" -->
       <ng-container matColumnDef="personal" >
        <th mat-header-cell *matHeaderCellDef>Personal</th>
        <td mat-cell *matCellDef="let element"> 
            <div class="col-md-12">

            <mat-select matNativeControl class="form-control small font " name="personal" [(ngModel)]="element.isPersonalEnabled" >
            <mat-option class="mat-primary" value="true">Enabled</mat-option>
            <mat-option class="mat-primary" value="false">Disabled</mat-option>

          </mat-select>  
        </div>
         </td>
       </ng-container>

       
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsCreditDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
      
      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsCreditDisplay"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsCreditDisplay;"
      class="example-element-row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
      <div *ngIf="mediumlist.length>0" class="col-md-12 mt-4" style="text-align: right;">
        <button  class="btn btn-outline-success  shadow " style="padding-left: 50px;padding-right: 50px; padding-top: 5px;padding-bottom: 5px;"  (click)="savePaymentMedium()">Save</button>
        </div>
      </div>
      
      
  

</div> 